// extracted by mini-css-extract-plugin
export var background = "br_x";
export var backgroundContainer = "br_fj";
export var bottomImage = "br_t";
export var bottomImageContainer = "br_fr";
export var buttons = "br_cD";
export var container = "br_b";
export var imagesContainer = "br_fq";
export var middleWave = "br_cS";
export var section = "br_d";
export var text = "br_b6";
export var textContainer = "br_cq";
export var title = "br_h";
export var topImage = "br_m";
export var waveOverlay = "br_fp";